import {
  CIRCLE_TOGGLE_ACTIVE_COLOR,
  CIRCLE_TOGGLE_ICON_SIZE,
  CIRCLE_TOGGLE_INACTIVE_COLOR,
  CIRCLE_TOGGLE_PADDING,
} from "../types/constants";
import { AddCircle as AddCircleIcon } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import React from "react";

/** Small circular plus icon button showing an on/off state. */
export function CircleToggleButton({ active, title, onClick, onMouseDown }) {
  return (
    <Tooltip title={title}>
      <IconButton
        size={"small"}
        aria-label={title}
        aria-pressed={Boolean(active)}
        onClick={onClick}
        onMouseDown={onMouseDown}
        sx={{ p: CIRCLE_TOGGLE_PADDING, flexShrink: 0 }}
      >
        <AddCircleIcon
          sx={{
            fontSize: CIRCLE_TOGGLE_ICON_SIZE,
            color: active
              ? CIRCLE_TOGGLE_ACTIVE_COLOR
              : CIRCLE_TOGGLE_INACTIVE_COLOR,
          }}
        />
      </IconButton>
    </Tooltip>
  );
}

export default CircleToggleButton;
